import React from 'react';
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Core Engines We Use For Game Development</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
            Here are the technologies that TekRevol utilizes in developing mobile game apps:
            </p>
          </Col>
        </Row>
        <Row>
        <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Game Engines">
              <ul>
                <li>Unity</li>
                <li>Unreal Engine</li>
                <li>CryEngine</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Programming Languages">
              <ul>
                <li>C</li>
                <li>C++</li>
                <li>C#</li>
                <li>Swift</li>
                <li>HTML5</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Operating System">
              <ul>
                <li>Android OS</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Platforms">
              <ul>
                <li>Amazon Web</li>
                <li>Services (AWS)</li>
                <li>Microsoft Azure</li>
                <li>Google Cloud</li>
                <li>Platform (GCP)</li>
                <li>Firebase</li>
                <li>AppCenter for CI/CD</li>
                <li>Kubernetes</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Google Assistant</li>
                <li>Google VR</li>
                <li>Machine Learning(ML Kit)</li>
                <li>Firebase</li>
                <li>Google Cloud</li>
                <li>Google Analytics</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
